import {put, takeEvery, delay, select} from 'redux-saga/effects';
import {
	allowMarketing,
	checkPhoneCode,
	getCustomer,
	loginAnonymous,
	setBirthdate,
	setEmail, setGuestInfo,
	setLocale,
	setName,
	setPhone,
} from 'new-actions/api.actions.ts';
import {
	CONFIRM_PHONE,
	CONFIRM_PHONE_CODE, CONFIRM_SET_GUEST, GUEST_ORDER_LOGIN_ANONYMOUSLY,
	SET_EMAIL_MARKETING_CONSENT,
	SET_SMS_MARKETING_CONSENT,
} from 'new-constants/customer.constants';
import {
	DONE_BIRTHDAY,
	DONE_EMAIL,
	DONE_NAME,
	DONE_SELECT_LANGUAGE,
	OPEN_INITIAL,
} from 'new-constants/popup.constants';
import {START} from 'new-constants/app-state.constants';
import {
	getCurrentAppIdSelector,
	getCurrentAuthSelector,
	getCurrentCustomerSelector,
	getCurrentRestaurantIdSelector
} from '../selectors';
import {PRIVATE_RELOAD_CUSTOMER_DETAILS} from 'new-constants/pusher.constants';
import {STRIPE_SUCCESS, VIPPS_SUCCESS} from 'new-constants/payment.constants';
import {ADYEN_SUCCESS} from "../constants/payment.constants";
import {DONE_CARD_STATUS} from "../constants/popup.constants";
import {CHECK_ADYEN_PAYMENT_SUCCESS} from "../constants/api.constants";
import {getCalculatedGlobalShortLocale} from "helpers/localization.helper";
import {CustomerType} from "reducers/customer.reducer.types";

function* sendPhone(action) {
	yield put(setPhone(action.phone));
}

function* sendPhoneCode(action) {
	yield put(checkPhoneCode(action.phoneCode, action.termsConsent, action.marketingConsent, action.shouldOpenCartOnLogin));
}

function* sendLanguage(action) {
	yield put(setLocale(action.language));
}

function* sendName(action) {
	yield put(setName(action.name));
}

function* sendEmail(action) {
	yield put(setEmail(action.email));
}

function* sendBirthdate(action) {
	yield put(setBirthdate(action.birthday));
}
function* refreshCustomerIfNeeded(action){
	yield delay(1000);
	const state = yield select();

	const currentCustomer = getCurrentCustomerSelector(state);
	if (currentCustomer.type === CustomerType.GUEST && !action.returnFromAdyen) {
		const currentAppId = getCurrentAppIdSelector(state);
		const locale = getCalculatedGlobalShortLocale(currentCustomer);
		yield put(loginAnonymous(currentAppId, locale));
		return;
	}
	const CacheLifetime = 10 * 1000;
	if(Math.abs(currentCustomer.fetchedTimestamp - Date.now()) < CacheLifetime){
		return;
	}

	if (!getCurrentAuthSelector(state)) {
		return;
	}

	yield put(getCustomer(getCurrentRestaurantIdSelector(state)));
}

function* refreshCustomer(action) {
	yield delay(1000);
	const state = yield select();

	if (!getCurrentAuthSelector(state)) {
		return;
	}

	yield put(getCustomer(getCurrentRestaurantIdSelector(state)));
}

function* sendEmailMarketingConsent(action) {
	const state = yield select();
	const marketing = getCurrentCustomerSelector(state)?.marketing;
	yield put(allowMarketing(action.newEmailMarketingConsent, marketing?.allowPush, marketing?.allowSms));
}

function* sendSmsMarketingConsent(action) {
	const state = yield select();
	const marketing = getCurrentCustomerSelector(state)?.marketing;

	yield put(allowMarketing(marketing?.allowEmail, marketing?.allowPush, action.newSmsMarketingConsent));
}

function* sendGuestInfo(action) {
	yield put(setGuestInfo(action.name, action.phone, action.acceptTerms));
}

function* guestOrderLoginAnonymously() {
	const state = yield select();
	const {customer} = state;
	const currentAppId = getCurrentAppIdSelector(state);
	const locale = getCalculatedGlobalShortLocale(customer);
	yield put(loginAnonymous(currentAppId, locale));
	yield put(delay(1000));
	yield put(getCustomer(getCurrentRestaurantIdSelector(state)));
}

export const customerSaga = function* customerSaga() {
	yield takeEvery([START, OPEN_INITIAL], refreshCustomerIfNeeded);
	yield takeEvery(
		[PRIVATE_RELOAD_CUSTOMER_DETAILS, STRIPE_SUCCESS, VIPPS_SUCCESS, ADYEN_SUCCESS, DONE_CARD_STATUS, CHECK_ADYEN_PAYMENT_SUCCESS],
		refreshCustomer
	);
	yield takeEvery([CONFIRM_PHONE], sendPhone);
	yield takeEvery([CONFIRM_PHONE_CODE], sendPhoneCode);
	yield takeEvery([DONE_SELECT_LANGUAGE], sendLanguage);
	yield takeEvery([DONE_EMAIL], sendEmail);
	yield takeEvery([DONE_NAME], sendName);
	yield takeEvery([DONE_BIRTHDAY], sendBirthdate);
	yield takeEvery([SET_EMAIL_MARKETING_CONSENT], sendEmailMarketingConsent);
	yield takeEvery([SET_SMS_MARKETING_CONSENT], sendSmsMarketingConsent);
	yield takeEvery([CONFIRM_SET_GUEST], sendGuestInfo);
	yield takeEvery(GUEST_ORDER_LOGIN_ANONYMOUSLY, guestOrderLoginAnonymously);
};
